function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/*
 *  Variant Selector
 *    Scripts for the Variant Selector.
 *
 *
 *  Version:
 *    1.0.0 - 2020/03/03
 */

import { jsonFromjQuery, setQueryParams } from '@process-creative/slate-theme-tools';

//Selectors
export var VARIANT_SELECTOR_SELECTOR = '[data-variant-selector]';
export var PRODUCT_JSON_SELECTOR = '[data-product-json]';

//Events
export var ON_VARIANT_CHANGE = 'onVariantChange';

//Errors
export var ERROR_MISSING_SELECTOR = "Could find the variant selector element!";
export var ERROR_NO_JSON = "Attempted to load the variant selector, however there is no ".concat(PRODUCT_JSON_SELECTOR, " found on the page");
export var ERROR_MULTIPLE_JSON = "Variant Selector found multiple ".concat(PRODUCT_JSON_SELECTOR, " elements, this could affect it's functionality.");
export var ERROR_INVALID_JSON = "Variant Selector failed to load Product JSON!";
export var ERROR_SELECTED_INVALID_VARIANT = "Cannot set this variant, the ID was not found in the product data!";

//Class
export var VariantSelector = /*#__PURE__*/function () {
  function VariantSelector(container, data) {
    _classCallCheck(this, VariantSelector);
    this.container = container;
    this.selector = this.getVariantSelector();
    if (!this.selector || !this.selector.length) throw new Error(ERROR_MISSING_SELECTOR);
    this.currentId = this.selector.val();
    if (!data) {
      //Try and find the product json...
      var jsonElement = [function () {
        return container.find(PRODUCT_JSON_SELECTOR);
      }, function () {
        return container.closest(PRODUCT_JSON_SELECTOR);
      }, function () {
        return $(PRODUCT_JSON_SELECTOR);
      }].find(function (e) {
        var x = e();
        return x && x.length;
      });
      if (!jsonElement) throw new Error(ERROR_NO_JSON);
      jsonElement = jsonElement();
      if (!jsonElement || !jsonElement.length) throw new Error(ERROR_NO_JSON);
      if (jsonElement.length > 1) console.error(ERROR_MULTIPLE_JSON);
      try {
        data = jsonFromjQuery(jsonElement);
      } catch (e) {
        console.error(ERROR_INVALID_JSON);
        throw e;
      }
    }
    this.data = data;
    this.attachEvents();
  }
  _createClass(VariantSelector, [{
    key: "shouldUseEvents",
    value: function shouldUseEvents() {
      return true;
    }
  }, {
    key: "getVariantSelector",
    value: function getVariantSelector() {
      return this.container.find(VARIANT_SELECTOR_SELECTOR);
    }
  }, {
    key: "getProductData",
    value: function getProductData() {
      var p = _objectSpread({}, this.data);
      p.variants = p.variants.map(function (v) {
        return _objectSpread(_objectSpread({}, v), {}, {
          product: p
        });
      });
      return p;
    }
  }, {
    key: "getSelectedVariantId",
    value: function getSelectedVariantId() {
      return this.currentId;
    }
  }, {
    key: "getVariantData",
    value: function getVariantData(variant) {
      if (!variant) variant = this.getSelectedVariantId();
      var v = this.data.variants.find(function (v) {
        return v.id == variant;
      });
      return _objectSpread(_objectSpread({}, v), {}, {
        product: this.getProductData()
      });
    }
  }, {
    key: "setVariant",
    value: function setVariant(variantId) {
      //Find the variant that matches this ID
      var variant = this.getVariantData(variantId);
      if (!variant) throw new Error(ERROR_SELECTED_INVALID_VARIANT);

      //Update selector
      var selected = this.getSelectedVariantId();
      if (selected !== null && selected != variantId) this.selector.val(variant.id);

      //Update internal variable
      this.currentId = variant.id;

      //Fire event?
      if (this.shouldUseEvents()) {
        $(document).trigger(ON_VARIANT_CHANGE, [variant, variant.id]);

        //Update the url
        //TODO: This should become part of the product template
        var url = setQueryParams({
          variant: variant.id
        });
        history.replaceState({
          variant: variant,
          variantId: variantId
        }, document.title, url);
      }
      this.onVariantChanged(variant, variant.id);
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      this.boundVariantSelected = function (e) {
        return _this.onVariantSelected(e);
      };
      this.container.on('change', VARIANT_SELECTOR_SELECTOR, this.boundVariantSelected);
      if (this.shouldUseEvents()) {
        this.boundVariantChange = function (e, variant, variantId) {
          return _this.onVariantChange(e, variant, variantId);
        };
        $(document).on(ON_VARIANT_CHANGE, this.boundVariantChange);
      }
    }
  }, {
    key: "detachEvents",
    value: function detachEvents() {
      if (this.boundVariantSelected) this.container.off('change', VARIANT_SELECTOR_SELECTOR, this.boundVariantSelected);
      if (this.boundVariantChange) $(document).off(ON_VARIANT_CHANGE, this.boundVariantChange);
    }
  }, {
    key: "onVariantSelected",
    value: function onVariantSelected(e) {
      this.setVariant($(e.currentTarget).val());
    }
  }, {
    key: "onVariantChange",
    value: function onVariantChange(e, variant, variantId) {
      if (variantId == this.getSelectedVariantId()) return;
      this.setVariant(variantId);
    }
  }, {
    key: "onVariantChanged",
    value: function onVariantChanged(variant, id) {}
  }]);
  return VariantSelector;
}();